import PlaceholderScreen from '../../components/PlaceholderScreen/PlaceholderScreen'

export default function AppSettingsScreen() {
  return <PlaceholderScreen title="App Settings" />
}